import { reduxForm } from 'redux-form';

import {
  QueuesAgentsTableDispatchProps,
  QueuesAgentsTableFormValues,
  QueuesAgentsTable as QueuesAgentsTableImpl,
  QueuesAgentsTableOwnProps,
  QueuesAgentsTableStateProps,
} from '../components/queuesAgentsTable';

const FORM_NAME = 'queuesAgentsTableForm';

const QueuesAgentsTableForm = reduxForm<
  QueuesAgentsTableFormValues,
  QueuesAgentsTableOwnProps &
    QueuesAgentsTableStateProps &
    QueuesAgentsTableDispatchProps
>({
  form: FORM_NAME,
  enableReinitialize: true,
})(QueuesAgentsTableImpl);

export { QueuesAgentsTableForm as QueuesAgentsTable };
